import { CircularProgress, Tooltip, Typography } from "@mui/material"
import { translate } from "app/language/service"
import React, { useEffect, useState } from "react"
import { tagRPO } from "user-tag/repository"

interface IForecastTagsProps {
  campaignId: number
}

export const ForecastTags = React.memo(({ campaignId }: IForecastTagsProps) => {
  const [userTags, setUserTags] = useState("")
  const [isTagsLoaded, setIsTagsLoaded] = useState(false)
  const [hasError, setHasError] = useState(false)
  const errorLabel = translate("tags.error.server")
  useEffect(() => {
    tagRPO
      .getAllUserTagsForCampaign(campaignId)
      .then(tags => {
        setUserTags(tags.map(t => t.name).join(", "))
        setIsTagsLoaded(true)
      })
      .catch(error => {
        console.error(error)
        setHasError(true)
        setIsTagsLoaded(true)
      })
  }, [campaignId])
  return !isTagsLoaded ? (
    <CircularProgress />
  ) : (
    <Tooltip title={hasError ? errorLabel : userTags}>
      <Typography
        color={hasError ? "error" : "textPrimary"}
        fontSize=".8rem"
        fontWeight="300"
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}>
        {hasError ? errorLabel : userTags}
      </Typography>
    </Tooltip>
  )
})
